"use strict";

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Progress = _interopRequireDefault(require("../../../Progress"));
var Styled = _interopRequireWildcard(require("./ProgressSection.styles"));
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) {
    if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
      var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
      i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
  }
  return n["default"] = e, t && t.set(e, n), n;
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var ProgressSection = function ProgressSection(_ref) {
  var progressValue = _ref.progressValue,
    light = _ref.light;
  return /*#__PURE__*/_react["default"].createElement(Styled.ProgressSectionWrapper, null, /*#__PURE__*/_react["default"].createElement(_Progress["default"], {
    color: light ? 'secondary' : 'primary',
    kind: light ? null : 'inverse',
    value: progressValue,
    hidePercentage: true
  }));
};
ProgressSection.propTypes = process.env.NODE_ENV !== "production" ? {
  progressValue: _propTypes["default"].number,
  light: _propTypes["default"].bool
} : {};
var _default = exports["default"] = ProgressSection;